// Dónde vive el plan de una tanda de Videos cortos: en `agent_chats.lienzo` de la sesión (una
// fila de tipo `videos-cortos`), bajo la clave `videos_cortos`, como el Catálogo guarda el suyo
// bajo `catalogo` (ADR-2026-10-30-videos-cortos-con-el-agente). El autoguardado es el MISMO
// `Guardador` del Catálogo: debounce por huella y lo pendiente se guarda al desmontar.
import { useEffect, useRef } from 'react';
import { supabase } from '../../../../lib/supabase';
import { leerLienzo } from '../../agentChatApi';
import { Guardador } from '../catalogoAgente/planGuardado';
import { normalizarPlan, type PlanDeVideos } from './plan';

export const CLAVE_DEL_LIENZO = 'videos_cortos';

/** Lo crudo de `lienzo` → el plan, o null si no es una sesión de Videos cortos. Puro. */
export function planDeLienzo(raw: unknown): PlanDeVideos | null {
  const plan = (raw as Record<string, unknown> | null)?.[CLAVE_DEL_LIENZO];
  return plan ? normalizarPlan(plan) : null;
}

export async function leerPlanDeVideos(chatId: string): Promise<PlanDeVideos | null> {
  return planDeLienzo(await leerLienzo(chatId));
}

export async function guardarPlanDeVideos(chatId: string, plan: PlanDeVideos): Promise<boolean> {
  const { error } = await supabase.from('agent_chats').update({ lienzo: { [CLAVE_DEL_LIENZO]: plan } }).eq('id', chatId);
  if (error) {
    console.error('[videosCortos] guardarPlan', error);
    return false;
  }
  return true;
}

/** Guarda el plan cuando cambia (por huella), con debounce; al desmontar, lo pendiente se guarda igual. */
export function usePlanDeVideosGuardado(chatId: string | undefined, plan: PlanDeVideos | null): void {
  const guardador = useRef<Guardador<PlanDeVideos> | null>(null);
  if (!guardador.current) guardador.current = new Guardador<PlanDeVideos>(guardarPlanDeVideos);
  const primero = useRef(true);
  useEffect(() => {
    if (!chatId || !plan) return;
    if (primero.current) {
      primero.current = false;
      guardador.current!.recordar(chatId, plan);
      return;
    }
    guardador.current!.programar(chatId, plan);
  }, [chatId, plan]);
  useEffect(() => {
    const g = guardador.current!;
    return () => {
      void g.vaciar();
    };
  }, []);
}
